import { render, staticRenderFns } from "./captains_registration_requests_status.vue?vue&type=template&id=f8130336&scoped=true&"
import script from "./captains_registration_requests_status.vue?vue&type=script&lang=js&"
export * from "./captains_registration_requests_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8130336",
  null
  
)

export default component.exports